import { SEO } from "@/components/SEO";
import { CaseStudies, FreePlanCTA } from "@/components/marketing/Marketing";
export default function WorkPage() {
  return (
    <div className="growth">
      <SEO
        title="Real business systems we’ve built"
        description="Explore Better Systems AI work in lighting, wholesale, restaurants, and compost operations."
        url="https://www.bettersystems.ai/work"
      />
      <section className="hero">
        <div className="wrap">
          <span className="eyebrow">Our work</span>
          <h1>
            Different businesses.
            <br />
            <em>A simpler way to work.</em>
          </h1>
          <p className="intro">
            Practical systems for real teams. These examples show what we build
            and the workflows they support.
          </p>
        </div>
      </section>
      <section className="section" style={{ paddingTop: 0 }}>
        <div className="wrap">
          <CaseStudies />
          <p className="small" style={{ marginTop: 20 }}>
            Examples describe project scope and current development stages.
            Revenue and time-saving results are not quantified here.
          </p>
        </div>
      </section>
      <FreePlanCTA />
    </div>
  );
}
